// @flow
import { RESORT_PRICE_TICKET } from 'Client/cms/toolkit/constants';
import * as configQueries from 'Views/configQueries';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { buildProductArgs, buildCruiseArgs } from 'Utils/graphql';
import { LINE_PRODUCT_PRICE_TICKET } from 'Utils/request/requestDictionary';

export type CMSProps = {
  adult: string,
  adults: string,
  askForQuotation: string,
  book: string,
  collapseLabels: {
    collapse?: string,
    expand?: string,
  },
  departureCityLabel: string,
  departureDateFormat: string,
  departureDateLabel: string,
  durationPlaceholder: string,
  fromToPlaceholder: string,
  resortId: string,
  seeAllPrices: string,
};

export type GQLProps = {
  config: CMSContent,
  cruise: null | Cruise,
  product: null | Resort,
};

export const productPriceTicketResolver = {
  name: RESORT_PRICE_TICKET,
  resolve: (
    appContext: AppContext,
    props: CMSProps,
    pageContext: PageContext,
    location: ProductRouterLocation,
  ): Promise<GQLProps> => {
    const { urlParams } = location;
    const { resortId: productId, durationPlaceholder = '', fromToPlaceholder = '' } = props;
    const productArgs = buildProductArgs(productId, urlParams);
    const cruiseArgs = buildCruiseArgs(urlParams);

    const query = `query {
      product: resort(${productArgs}) {
        id
        name
        badgeIcon
        comfortLabel
        type
        destination {
          country
        }
        rangeId
        duration(message:"${durationPlaceholder}")
      }
      cruise(${cruiseArgs}) {
        fromToDestination(message: "${fromToPlaceholder}")
      }
      config {
        booking { form { withoutTransport } }
        ${configQueries.price()}
        resort {
          ${configQueries.resortStartingPrice()}
        }
        common {
          close
          comparator {
            backToSearch
          }
        }
        travelAdvisor {
          phoneNumber
          text
          href
          type
        }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_PRICE_TICKET,
      strictErrors: false,
    });
  },
};
